import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { FactService } from 'src/app/_services/fact.service';
import { SubTopicService } from 'src/app/_services/subTopic.service';

@Component({
  selector: 'app-fact-edit',
  templateUrl: './fact-edit.component.html',
  styleUrls: ['./fact-edit.component.css']
})
export class FactEditComponent implements OnInit {
  myForm:FormGroup=undefined

  fact:any=undefined
  subtopicList:any=[]
  mySubTopicList=[]
  idList:any=[]
  searchSubtopicForm:FormGroup=undefined
  loading=false
  errorSaving=false
  isSaving=false
  constructor(private subTopicService:SubTopicService, private router:Router,private activatedRoute:ActivatedRoute, private factService:FactService) { }
  get f() {
    return this.myForm.controls
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      myP=>{
        this.loading=true
        this.factService.getFactBookItem(myP['server_fact_id']).subscribe(
          {
            next:(data:ResultData)=>{
              this.fact=data.rs.data
              this.loading=false
              this.initSearchForm()
              this.onSearchFormChanges()
              this.initMainForm()
            }
          }

        )
      }
    )


  }
  on_submit(){
    this.isSaving=true
    let dd=this.formatData(this.myForm.value.body,this.myForm.value.explanation, this.myForm.value.truth)

    this.factService.editFact(dd).subscribe(
      {
        next:(data:ResultData)=>{
                 this.isSaving=false
                 let factIn = data.rs.data
                 if(factIn['server_fact_id']==0){
                   this.errorSaving=true
                 }
                 else{
                   this.router.navigate(['/admin/fact/show',factIn['server_fact_id']])
                 }
               }
             }

           )

         }
  formatData(body:string, explanation:string,truth:number){
    let data = new URLSearchParams();
    data.set('body', body);
    data.set('explanation', explanation);
    data.set('truth', truth.toString());
    data.set('id', this.fact.server_fact_id.toString());
    const identifierList = this.evaluateId(this.mySubTopicList)
    for(let i=0; i < identifierList.length;i++){
      data.append('subTopics', identifierList[i].toString());
    }

    return data.toString()
  }
  initMainForm(){
    this.myForm=new FormGroup({
      body: new FormControl(this.fact.body, [Validators.required,Validators.minLength(4)]),
      explanation: new FormControl(this.fact.explanation, [Validators.required,Validators.minLength(9)]),
      truth: new FormControl(this.fact.truth?1:0, [Validators.required]),
    });
  }
  initSearchForm(){
    this.searchSubtopicForm= new FormGroup(
       {'searchInput': new FormControl('')}
       )
       this.loadSubTopics()
       this.loading=false
   }

   loadSubTopics(){
     this.factService.getSubTopicByFact(this.fact.server_fact_id).subscribe({
      next: (data: ResultData) => {
        this.mySubTopicList = data.rs.data;
      }
    }
     )

   }
   onSearchFormChanges(): void {
     this.searchSubtopicForm.get('searchInput').valueChanges.subscribe(val => {
       if(val.length>2){

         this.subTopicService.searchSubTopic(val).subscribe(
           x=>{
             this.subtopicList=x
             this.idList = this.evaluateId(this.subtopicList)

           }
         )
     }else{
       this.subtopicList=[]
     }
   })
 }

 addSubtopic(server_subtopic_id:number){
  let item = this.locateSubTopic(server_subtopic_id)
  let currentIdList = this.evaluateId(this.mySubTopicList)
  if(!currentIdList.includes(item.id)){
    this.mySubTopicList.push(this.locateSubTopic(server_subtopic_id))
  }

 }
 removeItem(server_subtopic_id:number){
  this.removeItemFromArray(server_subtopic_id)
}

locateSubTopic(server_subtopic_id:number){
  let myS:any=undefined
  for( let i =0; i < this.subtopicList.length;i++){
    if(server_subtopic_id == this.subtopicList[i].id){
      myS=this.subtopicList[i]
      break
  }
}
return myS
}

removeItemFromArray(server_subtopic_id:number){
  let index=0
  for( let i =0; i < this.mySubTopicList.length;i++){
    if(server_subtopic_id == this.mySubTopicList[i].id){
      index=i
      this.mySubTopicList.splice(index,1)
      break
  }
}
}

evaluateId(myList:any){
  let iid=[]
  for( let i =0; i < myList.length;i++){
    iid.push(myList[i].id)
  }
  return iid
}
}
